/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {orderBy} from 'lodash';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {CustomProperty} from '../models/customProperty';

export class CustomPropertyStore extends EntityStore {
  properties = [];

  constructor(rootStore) {
    super(rootStore, 'properties', Api.properties, CustomProperty);
  }

  loadByType(type) {
    return this.loadAll({params: {type}});
  }

  /**
   * If orders is not specified in sortOrder, then the ordering defaults to ascending
   *
   * @param {String} type
   * @param {{orders: []<String>, iteratees: []<String>}} sortOrder
   * @returns {CustomProperty[]}
   */
  getByType({
    type,
    sortOrder = {iteratees: [], orders: []},
  }) {
    const properties = this.properties.filter((prop) => prop.type === type);
    if (sortOrder.iteratees.length) {
      return orderBy(properties, sortOrder.iteratees, sortOrder.orders);
    }

    return properties;
  }
}

decorate(CustomPropertyStore, {
  properties: observable,
  loadByType: action,
});
